import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Stack } from '@yonderland/andes-react';
import { useLabelsOverlay } from './useLabelsOverlay';
export const LabelsOverlay = ({ showGenderIcon, genderFeatureId, savingsPercentage, priceOverlay, showNewProductLabel, showOnlineExclusiveLabel, showSustainabilityLabel, maxLabels, testId, size, direction = 'col', }) => {
    const aemConfiguration = useAemConfig();
    const { market } = aemConfiguration;
    const { labels } = useLabelsOverlay({
        showGenderIcon,
        genderFeatureId,
        savingsPercentage,
        priceOverlay,
        showNewProductLabel,
        showOnlineExclusiveLabel,
        showSustainabilityLabel,
        size,
    });
    const labelsToShow = maxLabels ? maxLabels : market === 'nl' ? 2 : 3;
    if (labels.length === 0) {
        return null;
    }
    return (_jsx(Stack, { direction: direction, wrap: direction === 'row' ? 'wrap' : undefined, gap: direction === 'row' ? { base: '1', md: '3' } : '1', testId: testId, children: labels.slice(0, labelsToShow) }));
};
